/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The collapsible filter panel revealed by the status-row toggle: the search box
 * then the sort bar. Purely a layout container — every control is fully driven
 * by the reservation-list controls hook.
 */

import { ReservationListControls } from '@euler/app/flows/reservations/pages/list/functions/useReservationListControls';
import { View } from 'react-native';
import { ReservationSearchBox } from './ReservationSearchBox';
import { SortBar } from './SortBar';

// Not memoized: `controls` is a fresh object every render, so memo could never
// skip — and the panel only mounts while expanded, so re-renders are cheap.
export const ReservationFilterPanel = ({
  controls,
}: {
  controls: ReservationListControls;
}) => {
  return (
    <View>
      <ReservationSearchBox
        value={controls.searchText}
        onChange={controls.setSearchText}
      />
      <SortBar sortKey={controls.sortKey} onSelectSort={controls.setSortKey} />
    </View>
  );
};
